import CryptoJs, { CipherParams } from 'crypto-js'
import AES from 'crypto-js/aes'
import modeEcb from 'crypto-js/mode-ecb'
import padPkcs7 from 'crypto-js/pad-pkcs7'

// md5加密
export function md5Encrypt(password: string): string {
  return CryptoJs.MD5(password).toString()
}

/**
 * AES加密
 * @param word 要加密的内容
 * @param keyWord 加密key
 * @returns 加密后的字符串
 * https://cryptojs.gitbook.io/docs/
 */
export function aesEncrypt(word: string, keyWord: string): string {
  const key = CryptoJs.enc.Utf8.parse(keyWord)
  const encrypted: CipherParams = AES.encrypt(word, key, {
    mode: modeEcb,
    padding: padPkcs7
  }).ciphertext.toString(CryptoJs.enc.Hex)
  return encrypted
}

const objKeySort = (obj = {}) => {
  const sortedKeys = Object.keys(obj).sort() // 对 key 进行排序
  const resp = {}
  sortedKeys.forEach((k) => {
    resp[k] = obj[k]
  })
  return resp
}
/**
 * sign: SHA256 （apiUri@ts@nonce@bodystring@token）
 */
export const execSign = (body = {}, token = '') => {
  const ts = Date.now()
  const nonce = Math.random()
  const apiUri = '/operation-center-service/sys/login'
  const bodyString = JSON.stringify(objKeySort(body))
  const arr = [apiUri, ts, nonce, bodyString, token]
  const arrStr = arr.join('@')
  // console.log(arrStr)
  const sign = CryptoJs.SHA256(arrStr).toString()
  // console.log(sign)
  return {
    sign,
    ts,
    nonce
  }
}
